import {Component, EventEmitter, Input, OnInit, Output, SimpleChanges} from '@angular/core';
import {ProductVariant} from '../../../shared/interfaces/wheels';
import {ActivatedRoute, Params, Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {ApiServices} from '../../../shared/services/api.service';

import {DataService} from '../../../shared/services/data.service';
import {HelperService} from '../../../shared/services/helper.service';

import {Inventory} from '../../../shared/interfaces/ProductDetailResponse';
import {NgbModal, ModalDismissReasons, NgbModalRef} from '@ng-bootstrap/ng-bootstrap';
import {Subscription} from 'rxjs';
import * as $ from 'jquery';

@Component({
  selector: 'app-wheel-single',
  templateUrl: './wheel-single.component.html',
  styleUrls: ['./wheel-single.component.scss']
})
export class WheelSingleComponent implements OnInit {

    listPshow = true;

  @Input() product: ProductVariant;
  @Input() is_hide_cost:any;
  @Output() onViewDetail = new EventEmitter();
  @Input() viewDetailLoader = false;
  @Input() isRear = 0;

  warehouse_quantity:any = {};
  inventoryData:any = []
  clickedProductID:number = 0;

  productAddedToCart = null;
  successMessage: string = '';

  productCartTotalQty:number[] = [];
  prodQty:number[]=[];
  inventory: Inventory[];
  private cartItems: any[] = [];
  private cartProcessing = false;
  cartSubscription: Subscription;

  cartResp:any = null;
  prodAddons = [];
  cartaddons:any;
  cartId:any;
  productId:any;
  isCustomClassNeeded: boolean = true;
  offsetDropdownValues = [];
  isProductCustomization = false;
  custom_finish = '';
  custom_finish_price;
  bolt_pattern = 'recommended';
  offset = 'recommended';
  pc_cost_per_wheel;
  vehicle_year_make_model = '';
  p_customization_submitted = false;
  addToCartPopup: NgbModalRef;
  show_center_bore:boolean = false;
  show_wheel_weight:boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private toastr: ToastrService,
    private apiService: ApiServices,
    private modalService: NgbModal,
    private dataService: DataService,
  public helperService: HelperService
  ) {}

  ngOnInit(): void {
    this.show_center_bore = localStorage.getItem("show_center_bore") != null ? true : false;
    this.show_wheel_weight = localStorage.getItem("show_wheel_weight") != null ? true : false;
  }

  setWarehouse(product_id:number, warehouse_id, is_eta:boolean) {
    this.warehouse_quantity['warehouse_id'] = warehouse_id;
    this.warehouse_quantity['quantity'] = 1;
    this.warehouse_quantity['is_eta'] = is_eta;
    this.warehouse_quantity['product'] = product_id;
  }

  getInventoryByProduct(product_id, product_variant_id){
    let inventory_loader = document.querySelector(`#stockModal-${this.product.id}-${this.product.product_variant_id} .inventory_loader`) as HTMLElement;
    let inventory_table = document.querySelector(`#stockModal-${this.product.id}-${this.product.product_variant_id} .inventory_table`) as HTMLElement;
    inventory_table.style.display = "none";
    inventory_loader.classList.remove("d-none");
    inventory_loader.classList.add("d-flex");

    this.inventoryData = [];
    this.apiService.getInventoryByProduct({product_id: product_id, variant_id: product_variant_id}).subscribe(
      response => {
        inventory_table.style.display = "block";
        inventory_loader.classList.remove("d-flex");
        inventory_loader.classList.add("d-none");
        this.clickedProductID = product_id;
        this.inventoryData = response.data;
      }
    );
  }


   onAddToCart(product): void {
    const prodId = product.product_id;
    const variantId = product.product_variant_id;
    const inventory = product.product_inventory;

    let inv = inventory;
    let prodQtys = this.prodQty;
    let error = true;
    let items:any = [];

    let item:any = {};
    let warehouse_qunatity:any = {};

    let totalQty:number=0;

    item.product_id = prodId;
    item.product_variant_id = variantId;
    item.type = "";
    let product_eta = false;
    if (product.product_id === this.warehouse_quantity['product']) {
      product_eta = this.warehouse_quantity['is_eta'] == true ? true  : false;
      this.warehouse_quantity['quantity'] = product_eta ? this.prodQty[variantId] : 1;
      if (product_eta) {
        this.warehouse_quantity["eta"] = true;
      }
      delete this.warehouse_quantity['is_eta'];
      item.warehouse_qunatity = [this.warehouse_quantity]
    }

    var _self = this;



    inv.forEach(function(v,i){
      
      if(prodQtys[variantId+'_'+v.warehouse.id] > (v.quantity+v.eta_qty)){
        _self.toastr.error("Invalid quantity. "+v.warehouse.warehouse_name+" have only "+v.quantity+" quantity left.", 'Error');
      }
      else if(prodQtys[variantId+'_'+v.warehouse.id] <= 0 ){
        _self.toastr.error("("+v.warehouse.warehouse_name+") Invalid quantity.", 'Error');
      }
      else if(prodQtys[variantId+'_'+v.warehouse.id] > 0 ) {
        if(typeof prodQtys[variantId+'_'+v.warehouse.id] !== 'undefined'){
          error = false;
          totalQty += prodQtys[variantId+'_'+v.warehouse.id] || 0;
          warehouse_qunatity = {};
          warehouse_qunatity.warehouse_id = v.warehouse.id;
          warehouse_qunatity.quantity = prodQtys[variantId+'_'+v.warehouse.id];
          item.warehouse_qunatity.push(warehouse_qunatity);
        }

      }
      
    });
    item.quantity = totalQty;
    items.push(item);

    /*if(totalQty < 4){
      error = true;
      this.toastr.error("Minimum purchase quantity should be 4", 'Error');
    }*/

    if(!error){

      this.productCartTotalQty[variantId] = totalQty;
      this.cartItems = items;
      this.addToCart(product);

    } else {
      this.productCartTotalQty[variantId] = 0;
    }
  }
  addToCart(product): void {
    this.prodAddons = [];
    // tslint:disable-next-line:variable-name
    const session_id = localStorage.getItem('session_id');
    const data = {
      session_id,
      items: this.cartItems,
    };
    this.cartProcessing = true;
    this.cartSubscription = this.apiService.addToCart(data).subscribe(
      response => {
        this.cartProcessing = false;
        if (response.status) {

          this.productAddedToCart = product;

          let totalItem =  this.cartItems.length;

          this.cartResp = response.data;

          if(this.cartResp.is_offset_drilling){
            this.generateOffsetDropdownValues(this.productAddedToCart.offset);
          }
          
          if(this.cartResp.bolt_batterns && this.cartResp.bolt_batterns.length>0){
            this.cartResp.bolt_batterns.sort((a, b) => {
              // Extracting the numerical part of the bolt strings
              const numA = parseFloat(a.split("x")[1]);
              const numB = parseFloat(b.split("x")[1]);
          
              // Comparing the numerical parts
              return numA - numB;
          });
          }

          if((this.cartResp.product_customizations && this.cartResp.product_customizations.length>0) || (this.cartResp.bolt_batterns && this.cartResp.bolt_batterns.length>0) || (this.offsetDropdownValues && this.offsetDropdownValues.length>0)){
              this.isProductCustomization = true;
          }else{
              this.isProductCustomization = false;
          }
          this.pc_cost_per_wheel = this.cartResp.pc_cost_per_wheel ? this.cartResp.pc_cost_per_wheel : '';

          this.apiService.getCart().subscribe(response => {
              if (response.status) {
                this.dataService.setCartData(response);
              }
          });

          this.apiService.getAddsOnByProduct(this.cartItems[0].product_id).subscribe(
            response => {
              if(response.status){
                this.prodAddons = response.data;
              }
            },
            error => {}
          );

          let element:HTMLElement = document.getElementById('auto_trigger') as HTMLElement;
          // element.click();
          //this.successMessage = response.message;
          this.toastr.success(response.message, 'Success');
          
        }
      }, error => {
        this.cartProcessing = false;
        this.toastr.error(error.error.message, 'Error');
      }
    );

  }

  getSetOfFourPrice(product: any){
    let total = 0;
    if (product.discounted_price > 0 && this.listPshow) {
      if (!this.is_hide_cost) {
        total += parseFloat(product.discounted_price) * 2
      } else {
        total += parseFloat(product.us_retail_price) *2 ;
      }
    }
    if (product.rear_discounted_price > 0 && this.listPshow){
      if (!this.is_hide_cost) {
        total += parseFloat(product.rear_discounted_price) * 2
      } else {
        total += parseFloat(product.rear_price) * 2
      }
    
    } else {
      if (product.discounted_price > 0 && this.listPshow) {
        if (!this.is_hide_cost) {
          total += parseFloat(product.discounted_price) * 2
        } else {
          total += parseFloat(product.us_retail_price) *2 ;
        }
      }
    }
    return total;
  }

  closeModalAndRedirectCart = () => {
    this.modalService.dismissAll();
    this.router.navigateByUrl('/cart');
  }



  // addToCart = (product: ProductVariant) => {
  //   this.product.loading = true;
  //   this.onViewDetail.emit(product);
  // }

  ngOnChanges(changes: SimpleChanges) {
    if (this.product && !Array.isArray(this.product.images)) {
      this.product.images = JSON.parse(this.product.images);
    }
  }

  notifyAddToCart(product):void {
    const prodId = product.product_id;
    const variantId = product.product_variant_id;
    const inventory = product.product_inventory;

    this.apiService.notifyAddToCart(variantId).subscribe(
      response => {
        if(response.status){
          this.toastr.success('Alert set!', 'Success');
        }
      },
      error => {}
    );

  }

  productQtyCheck = (inventory) => {
    let totalQty = 0;
    inventory.forEach(function (inv) {
      // console.log(inv.eta_qty);
      // console.log(inv.quantity);
      totalQty += inv.eta_qty + inv.quantity;
    }); 
    // console.log(totalQty);
    return totalQty;
  }

  generateOffsetDropdownValues(offset):void {
    this.offsetDropdownValues = [];
    // Parse offset value
    const parts = offset.split(/\/|to|-/);
    if (parts.length === 1) {
      // If only one value, assume it's a single offset
      this.offsetDropdownValues = [];
    } else if (parts.length === 2) {
      // If two values, assume it's a range
      const start = parseFloat(parts[0]);
      const end = parseFloat(parts[1]);
      if (!isNaN(start) && !isNaN(end)) {
        for (let i = start; i <= end; i++) {
          this.offsetDropdownValues.push(i);
        }
      }
    }
    this.offsetDropdownValues.sort((a, b) => a - b);
  }

  addEditQty(warehouseCode, warehouseId, warehouseTotalQty, variantId, inventory, eta_qty=0, qty):void{

    let index = variantId+'_'+warehouseId;

    this.productCartTotalQty[variantId] = 0;
    this.prodQty[index] = qty;

    let inv = inventory;
    let totalQty = 0;
    let prodQty = this.prodQty;

    let allQtySum = eta_qty+warehouseTotalQty;

    if(qty > allQtySum){
      this.toastr.error("Invalid quantity. "+warehouseCode+" have only "+allQtySum+" quantity left.", 'Error');
    }
    else if(qty > 0) {
      inv.forEach( function(v,i) {
        if(typeof prodQty[variantId+'_'+v.warehouse.id] !== 'undefined'){
          totalQty += prodQty[variantId+'_'+v.warehouse.id] || 0;
        }
      } );
    }
    else if(qty < 0) {
      this.toastr.error("("+warehouseCode+") Invalid quantity.", 'Error');
    }

    this.productCartTotalQty[variantId] = totalQty;
  }



}
